<template>
    <div class="card" @click="click" role="button">
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-12 col-md-5 text-truncate">
                    <a href="javascript:void(0)">
                        {{ profile.application.name }}
                    </a>
                    <div>
                        <span class="text-muted">
                            <small>
                                <em>
                                    #{{ profile.application.id }}
                                </em>
                            </small>
                        </span>
                    </div>
                </div>
                <div class="col-10 col-md-5 text-truncate">
                    <a href="javascript:void(0)">
                        {{ profile.name }}
                    </a>
                    <div>
                        <span class="text-muted">
                            <small>
                                <em>
                                    #{{ profile.id }}
                                </em>
                            </small>
                        </span>
                    </div>
                </div>
                <div class="col-2 text-end" @click.stop>
                    <ActionDropdown :actions="actions" />
                </div>
            </div>
        </div>
    </div>
    <DangerModal :message="i18n('Remove %s?').replace('%s', profile.name)" ref="DangerModal" @confirmed="deleteItem" />
</template>

<script>
import api from "@/api.js";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import DangerModal from "@/components/common/confirm/DangerModal.vue";

export default {
    components: {
        ActionDropdown,
        DangerModal,
    },
    emits: ['updated'],
    props: {
        role: {
            type: Object,
            default() {
                return {};
            },
        },
        profile: {
            type: Object,
            default() {
                return {};
            },
        },
        expires_at: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        click() { },
        deleteItem() {
            this.$root.setSaving(true);
            api.delete('profiles/' + this.profile.id + '/roles/' + this.role.id).then(() => {
                this.$root.setSaved(true);
                this.$root.setLoading(false);
                let index = (this.role.profiles || []).map(e => e.id).indexOf(
                    this.profile.id);

                if (index !== -1) {
                    this.role.profiles.splice(index, 1);
                }

                this.$emit('updated');
            }).catch((err) => {
                this.$root.setSaved(true);
            });
        },
    },
    computed: {
        actions() {
            return [{
                label: this.i18n('Remove'),
                fn: () => {
                    if (!this.$refs['DangerModal']) return;
                    this.$refs['DangerModal'].show();
                },
            },];
        },
    }
};
</script>